(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfc-faq"] && !Shopify.designMode) return;
  try {
    
function stToggleFaq(btn) {
  var item = btn.closest('.st-faq-item');
  var isOpen = item.classList.contains('st-open');

  // Close all
  document.querySelectorAll('.st-faq-item.st-open').forEach(function(el) {
    el.classList.remove('st-open');
    el.querySelector('.st-faq-q').setAttribute('aria-expanded', 'false');
  });

  // Open clicked if it was closed
  if (!isOpen) {
    item.classList.add('st-open');
    btn.setAttribute('aria-expanded', 'true');
  }
}

  } catch(e) { console.error(e); }
})();
})();
